import { render, staticRenderFns } from "./PopupTutoWelcome.vue?vue&type=template&id=1fd5cfde&scoped=true&"
import script from "./PopupTutoWelcome.vue?vue&type=script&lang=js&"
export * from "./PopupTutoWelcome.vue?vue&type=script&lang=js&"
import style0 from "./PopupTutoWelcome.vue?vue&type=style&index=0&id=1fd5cfde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd5cfde",
  null
  
)

export default component.exports